import { render, staticRenderFns } from "./partner-login.vue?vue&type=template&id=0227251f&scoped=true&lang=pug&"
import script from "./partner-login.vue?vue&type=script&lang=js&"
export * from "./partner-login.vue?vue&type=script&lang=js&"
import style0 from "./partner-login.vue?vue&type=style&index=0&id=0227251f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227251f",
  null
  
)

export default component.exports